import axios from "axios";

const endpoint_url = "/campaignV2/customer/luckyDraw/fulfillClaim";

const updateWinnerClaimFulfillmentStatus = ({
  luckyDrawUuid,
  winnerUuid,
  winnerUuids,
  status,
  adminNotes,
}) => {
  const body = {
    luckyDrawUuid,
    status,
  };

  // Support both single winner (backward compatibility) and multiple winners
  if (winnerUuids && Array.isArray(winnerUuids)) {
    body.winnerUuids = winnerUuids;
  } else if (winnerUuid) {
    body.winnerUuid = winnerUuid;
  }

  // Add admin notes if provided
  if (adminNotes !== undefined && adminNotes !== null) {
    body.adminNotes = adminNotes;
  }

  return new Promise((resolve, reject) => {
    axios
      .post(endpoint_url, body)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response?.data || error);
      });
  });
};

export default updateWinnerClaimFulfillmentStatus;
